import { render, staticRenderFns } from "./orderSubmit.vue?vue&type=template&id=7b9c4c33&scoped=true&"
import script from "./orderSubmit.vue?vue&type=script&lang=js&"
export * from "./orderSubmit.vue?vue&type=script&lang=js&"
import style0 from "./orderSubmit.vue?vue&type=style&index=0&id=7b9c4c33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9c4c33",
  null
  
)

export default component.exports